<div class="login-container" *transloco="let t">
  <div class="login-card">
    <div class="login-card__logo">
      <img src="assets/images/logos/beetrics-logo.svg" alt="Beetrics Logo" class="logo-large" />
      <img
        src="assets/images/logos/beetrics-logo-small.svg"
        alt="Beetrics Logo"
        class="logo-small"
      />
    </div>

    <div class="login-card__header">
      <p class="login-subtitle-bold">{{ t('login.subtitle') }}</p>
      <p class="login-subtitle">
        <span class="desktop-text">{{ t('login.instructions') }}</span>
        <span class="mobile-text">{{ t('login.instructionsMobile') }}</span>
      </p>
    </div>

    <form class="login-form" [formGroup]="form" (ngSubmit)="onSignIn()">
      <div class="form-fields">
        <div class="form-group">
          <label for="username" class="form-label">{{ t('login.form.username.label') }}</label>
          <input
            type="email"
            id="username"
            formControlName="username"
            class="form-input"
            [class.form-input--error]="hasLoginError"
            [placeholder]="t('login.form.username.placeholder')"
            [attr.aria-invalid]="hasLoginError"
          />
        </div>

        <div class="form-group">
          <label for="password" class="form-label">{{ t('login.form.password.label') }}</label>
          <div class="password-input-container">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="form-input form-input--with-toggle"
              [class.form-input--error]="hasLoginError"
              [placeholder]="t('login.form.password.placeholder')"
              [attr.aria-invalid]="hasLoginError"
              [attr.aria-describedby]="hasLoginError ? 'login-error' : null"
            />
            <button type="button" class="password-toggle" (click)="togglePasswordVisibility()">
              <svg
                [class.hidden]="showPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              <svg
                [class.hidden]="!showPassword"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
                />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            </button>
          </div>
          @if (hasLoginError) {
          <p id="login-error" class="form-error" role="alert">{{ t(loginErrorMessageKey) }}</p>
          }
        </div>
      </div>

      <button type="submit" class="login-btn" [disabled]="form.invalid">
        <span>{{ t('login.actions.submit') }}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12,5 19,12 12,19" />
        </svg>
      </button>
    </form>
  </div>
</div>
